import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['chevron', 'moreLessText'];

  toggle() {
    if (this.hasMoreLessTextTarget) {
      this.moreLessTextTarget.textContent = this.moreLessTextTarget.textContent == 'more' ? 'less' : 'more';
    }
  }
}
